module.exports = __webpack_public_path__ + "static/empowering-blur-2052bf4b9a9e720209c19ba84bfa5fe9.jpg";